import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Marker from './Marker.jsx';
import { ProductHotspotOnce, InteractedOnce, ProductHotspotClicked } from '../../utils/Analytics.js';
import HotspotCircle from './ReactSVGHotspots/HotspotCircle.jsx';
import HotspotPlus from './ReactSVGHotspots/HotspotPlus.jsx';
import { getactivateProductModalKey, getHotspotIconStyle, missingSKUMap } from '../../utils/StoreConfigManager';
import TemplateProductModal from '../ui/modals/product/TemplateProductModal/TemplateProductModal';
import ProductModal from '../ui/modals/product/extended-product-modal/ui/ProductModal';

import ProductModalContextComponent from '../ui/modals/product/ProductModalContextComponent.jsx';
import { ProductModalContext } from '../ui/modals/product/ProductModalContext.jsx';
import { curatedProducts } from '../../utils/CuratedProductsData.js';
import I18NextContext from '../ui/i18next-context/I18NextContext.jsx';
import HotspotNew from './ReactSVGHotspots/HotspotNew.jsx';
import { AppContext } from '../../AppContext.jsx';


class ProductMarker extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onModalHidden = this.onModalHidden.bind(this);
        this.onProductTitleLoaded = this.onProductTitleLoaded.bind(this);
        this.onProductDataLoaded = this.onProductDataLoaded.bind(this);
        this.state = {
            isShowingModal: false,
            svgSprite: HotspotNew,
        };
        this.mounted = false;
        this.productTitle = null;
    }

    componentDidMount() {
        getHotspotIconStyle()
            .then(icon => {
                const Sprite = icon == 'blank' ? HotspotCircle : HotspotPlus;
                this.setState({ svgSprite: HotspotNew });
            })
            .catch(error => console.error(error));
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.quizSceneProductSku !== this.props.quizSceneProductSku) {
            this.onProductDataLoaded();
        }
    }

    onProductTitleLoaded(productTitle) {
        this.productTitle = productTitle;
    }

    onProductDataLoaded() {
        const activateProductSku = sessionStorage.getItem(getactivateProductModalKey());
        if (activateProductSku === this.props.productSKU) {
            sessionStorage.removeItem(getactivateProductModalKey())
            this.onClick();
        }
    }

    onClick() {
        if (!this.mounted) {
            return;
        }
        
        ProductHotspotOnce();
        InteractedOnce();
        if (this.productTitle) {
            ProductHotspotClicked(this.props.productSKU, this.productTitle);
        }
        this.setState({ isShowingModal: true });
    }

    onModalHidden() {
        if (!this.mounted) {
            return;
        }
        this.setState({ isShowingModal: false });
    }

    render() {
        const { productSKU, specialUrl, currentLanguage } = this.props;
        const { svgSprite, isShowingModal } = this.state;

        const updatedproductSKU = (currentLanguage in missingSKUMap && productSKU in missingSKUMap?.[currentLanguage]) ? missingSKUMap?.[currentLanguage]?.[productSKU] : productSKU;
        
        return (
            <ProductModalContextComponent ProductSKU={updatedproductSKU} CuratedProducts={curatedProducts[productSKU]} onProductTitleLoaded={this.onProductTitleLoaded} onProductDataLoaded={this.onProductDataLoaded}>
                <div>
                    <ProductModalContext.Consumer>
                        {value => (
                            <>
                            {isShowingModal &&  (
                                <ProductModal
                                    sku={productSKU}
                                    onClose={this.onModalHidden}
                                    specialUrl={specialUrl}
                                    setRelatedProducts={value.setRelatedProducts}
                                />

                            )}
                            <Marker
                                transform={this.props.transform}
                                colliderTransform={this.props.colliderTransform}
                                svgSprite={svgSprite}
                                primaryColor={this.props.primaryColor}
                                secondaryColor={this.props.secondaryColor}
                                showVisual={this.props.showVisual}
                                onClick={this.onClick}
                            />
                            </>
                        //         : (
                        //             <TemplateProductModal
                        //                 sku={productSKU}
                        //                 onClose={this.onModalHidden}
                        //                 specialUrl={specialUrl}
                        //                 onProductTitleLoaded={this.onProductTitleLoaded}
                        //             />
                        //         ))
                        )}
                    </ProductModalContext.Consumer>
                </div>
            </ProductModalContextComponent>
        );
    }
}

ProductMarker.propTypes = {
    color: PropTypes.string,
    productSKU: PropTypes.string.isRequired,
    transform: PropTypes.array.isRequired,
    colliderTransform: PropTypes.array.isRequired,
    specialUrl: PropTypes.string,
    primaryColor: PropTypes.string.isRequired,
    secondaryColor: PropTypes.string.isRequired
};

export default props => (
<I18NextContext.Consumer>
{i18Props => (
    <AppContext.Consumer>
    {appContextValue => (
        <ProductMarker
            {...props}
                currentLanguage={i18Props.currentLanguage}
                quizSceneProductSku={appContextValue.quizSceneProductSku}
            />
        )}
    </AppContext.Consumer>
     )}
</I18NextContext.Consumer>
)